import React from 'react';
import { FormattedMessage } from 'react-intl';


const CardComparisonOverviewSection = {
    sectionId: 'card-overview',
    sectionLabel: (
        <FormattedMessage
            id="edb.cc.side-by-side-v2.card-overview"
            defaultMessage="Card Overview"
        />
    ),
    items: [
        {
            cardPropertyKey: 'firstYearPointsInDollars',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.first-year-reward"
                    defaultMessage="First year reward"
                />
            ),
        },
        {
            cardPropertyKey: 'subsequentYearPointsInDollars',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.subsequent-year-reward"
                    defaultMessage="Subsequent year reward"
                />
            ),
        },
        {
            cardPropertyKey: 'welcomeOffer',
            cardPropertyKeyExpanded: 'welcomeOfferExpanded',
            isExpandable: true,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.welcome-offer"
                    defaultMessage="Welcome offer"
                />
            ),
        },
        {
            cardPropertyKey: 'anniversaryBonusDescription',
            cardPropertyKeyExpanded: 'anniversaryBonusExpanded',
            isExpandable: true,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.anniversary-offer"
                    defaultMessage="Anniversary Offer"
                />
            ),
        },
        {
            cardPropertyKey: 'annualFee',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.annual-fee"
                    defaultMessage="Annual Fee"
                />
            ),
        },
        {
            cardPropertyKey: 'rewardTypes',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.reward-type"
                    defaultMessage="Reward Type"
                />
            ),
        },
        {
            cardPropertyKey: 'earningCategories',
            cardPropertyKeyExpanded: 'earningCategoriesExpanded',
            isExpandable: true,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.earning-categories"
                    defaultMessage="Earning Categories"
                />
            ),
        },
        {
            cardPropertyKey: 'purchaseInterest',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.purchase-interest-rate"
                    defaultMessage="Purchase interest rate"
                />
            ),
        },
        {
            cardPropertyKey: 'cashAdvanceInterest',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.cash-advance-rate"
                    defaultMessage="Cash back advanced rate"
                />
            ),
        },
        {
            cardPropertyKey: 'balanceTransferInterest',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.balance-transfer-rate"
                    defaultMessage="Balance transfer rate"
                />
            ),
        },
        {
            cardPropertyKey: 'balanceTransferFee',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.balance-transfer-fee"
                    defaultMessage="Balance transfer fee"
                />
            ),
        },
        {
            cardPropertyKey: 'network',
            isExpandable: false,
            displayValue: (
                <FormattedMessage
                    id="edb.cc.side-by-side-v2.network"
                    defaultMessage="Network"
                />
            ),
        },
    ],
};

export default CardComparisonOverviewSection;
